<template>
  <div>
    <title>到店自提</title>
    <section class="serviceBox">
      <header class="tabHeader" v-if="ElementControls('opendoudian')==1">
        <p>
          <a :class="{'isActive':currentNav == 0}" @click="switchNav(0)">到店自提</a>
          <a :class="{'isActive':currentNav == 1}" @click="switchNav(1)">抖音蟹卡</a>
        </p>
      </header>
      <!--S 抖音蟹卡-->
      <DouYinVerify v-if="currentNav == 1"></DouYinVerify>
      <!--E 抖音蟹卡-->
      <template v-else>
      <!-- S 券卡验证表单 -->
      <el-form :model="serviceForm" inline class="serviceForm" :class="{'pt64':ElementControls('opendoudian')==1?true:false }">
        <el-form-item class="formTimeSlot">
          <el-select v-model="serviceForm.verifyType" :disabled="isCodeScanner">
            <el-option
              v-for="(item,index) in serviceTypeData"
              :label="item.name"
              :value="item.value"
              v-bind:key="item.value + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="codeSerIpt">
          <el-input
            v-show="serviceForm.verifyType == 0"
            :maxlength="!isCodeScanner?20:500"
            v-model.trim="serviceForm.cardCode"
            placeholder="填写券卡编码"
            clearable
            ref="codeRef"
            @keyup.enter.native="toNext(0)"
          ></el-input>
          <el-input
            v-show="serviceForm.verifyType == 1"
            v-model.trim="serviceForm.cardSerial"
            placeholder="填写序列号"
            clearable
            ref="serialRef"
            @keyup.enter.native="toNext(1)"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证密码" v-if="ischeckpwd==1" class="formTimeSlot" @keyup.enter.native="toNext(2)">
          <el-input v-model.trim="serviceForm.cardPwd" placeholder="填写卡密" clearable ref="pwdRef"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="validateLoading" @click="validate">验证</el-button>
        </el-form-item>
        <el-form-item v-if="ElementControls('openscanservice')==1">
          <el-checkbox v-model="isCodeScanner" @change="updateScanner">扫码仪模式</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            plain
            @click="getShowChoseMem(0)"
          >{{bindMemberInfo ? '取消绑定' : '绑定会员'}}</el-button>
        </el-form-item>
        <el-form-item v-show="memberBox">
          <div v-if="bindMemberInfo" class="inlineMember">
            <a>
              <img
                :src="bindMemberInfo.hpurl ? bindMemberInfo.hpurl : 'https://presale.jhtsoft.com/picms/c47519dc61feb.png'"
                alt="会员头像"
              />
            </a>
            <span>
              <i>昵称：</i>
              <em
                class="textFl"
                :title="bindMemberInfo.nickname ? bindMemberInfo.nickname : '匿名会员'"
              >{{bindMemberInfo.nickname ? bindMemberInfo.nickname : '匿名会员'}}</em>
              <b
                :class="[{iconmale: bindMemberInfo.sex == 0, iconfemale: bindMemberInfo.sex == 1}]"
              ></b>
            </span>
            <span>
              <i>会员等级：</i>
              <em
                class="textFl"
                :title="bindMemberInfo.mlevelname ? bindMemberInfo.mlevelname : ''"
              >{{bindMemberInfo.mlevelname ? bindMemberInfo.mlevelname : '--'}}</em>
            </span>
            <span v-if="bindMemberInfo.mphone">
              <i>手机号：</i>
              <em>{{bindMemberInfo.mphone ? bindMemberInfo.mphone : '--'}}</em>
            </span>
            <el-link type="primary" :underline="false" @click="getShowChoseMem(1)">修改</el-link>
          </div>
        </el-form-item>
      </el-form>
      <!-- S 券卡验证表单 -->

      <!--S 验证券卡列表-->
      <div class="serviceWrap">
        <p class="commonTit">
          <b>券卡信息</b>
          <em>
            (已验证
            <i class="commonNum">{{cardVertifyData.length}}</i> 张)
          </em>
          <span class="goodsSummary iconsw" @click="goodsSummary = true" v-if="cardVertifyData.length>0 || cardOrderno">商品汇总</span>
        </p>
        <el-table
          ref="cvTable"
          class="comTable cardVertifyTab"
          border
          :data="cardVertifyData"
          :maxHeight="tableHeight"
        >
          <el-table-column label="序号" type="index" fixed></el-table-column>
          <el-table-column label="券卡编码" fixed min-width="200">
            <template slot-scope="scope">
              <p>{{ scope.row.code}}</p>
              <em>【{{scope.row.serial}}】</em>
            </template>
          </el-table-column>
          <el-table-column label="本次消耗次数" min-width="200">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.consumpteTimes"
                v-on:change="consumpteTimesChange($event,scope.row)"
                size="mini"
                :min="1"
                :max="scope.row.residuenum"
                :step="1"
                step-strictly
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="剩余次数" prop="consumpteTimes" sortable min-width="130">
            <template slot-scope="scope">{{ scope.row.residuenum-scope.row.consumpteTimes}}</template>
          </el-table-column>
          <el-table-column label="已选商品" min-width="130">
            <template slot-scope="scope">
              <span
                class="cityName iconhand textFl"
                @click="getShowChoseGoods(scope.row)"
              >{{scope.row.goods.length}}</span>
            </template>
          </el-table-column>
          <el-table-column label="售卡渠道" prop="sellChannel" sortable min-width="120">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.sellChannel">{{ scope.row.sellChannel}}</p>
            </template>
          </el-table-column>
          <el-table-column label="面单打印说明" min-width="200">
            <template slot-scope="scope">
              <p
                class="textFl"
                :title="scope.row.printMemo"
              >{{scope.row.printMemo?scope.row.printMemo:'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="客服备注" min-width="200">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.memo">{{scope.row.memo?scope.row.memo:'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="出库备注" min-width="200">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.cardoutmemo">{{scope.row.cardoutmemo | empty}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <p class="handle">
                <span
                  v-if="scope.row.canChangeGoods"
                  title="更改商品"
                  @click="getShowChoseGoods(scope.row)"
                ><i class="iconedit"></i></span>
                <span title="删除" @click="deleteRow(scope.$index)"><i class="icondel"></i></span>
              </p>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData">
              <span>暂无数据</span>
            </div>
          </template>
        </el-table>
      </div>
      <!--E 验证券卡列表-->
      <!--S 提货表单-->
      <div class="deliveryForm">
        <p class="commonTit">
          <b>提货信息</b>
        </p>
        <el-form
          ref="telDeliveryForm_ref"
          :model="telDeliveryForm"
          label-width="70px"
          class="comForm"
        >
          <el-row class="goodsWrap">
            <el-col>
              <el-form-item label="订单备注">
                <el-input
                  type="textarea"
                  v-model="telDeliveryForm.orderMemo"
                  maxlength="100"
                  minlength="5"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!--E 提货表单-->
      <div class="bottomBtn">
        <el-button type="primary" :loading="submitLoading" @click="submitDeliveryForm()">提交</el-button>
        <el-button @click="$router.back(-1)">返回</el-button>
      </div>
      </template>
    </section>

    <!-- S 选择可选商品 -->
    <GoodsChoose
      v-if="goodsChoseDialogVisible"
      :delmode="0"
      :goodsChoseDialogVisible="goodsChoseDialogVisible"
      :lookOrEditType="lookOrEdit"
      :code="currentCode"
      :initUseTimes="currentUseTimes"
      :initSelectGoods="currentCodeInfo.goodsMap"
      :enAbleEdite="currentEnAbleEdite"
      @closeChild="getCloseGoodsCld"
      v-on:selectSubmit="goodsSelectSubmit($event)"
    ></GoodsChoose>
    <!-- E 选择可选商品 -->

    <!-- S 选择会员 -->
    <MemberChose
      v-if="memberChoseDialogVisible"
      :isAdd="1"
      :initSelected="bindMemberInfo"
      :memberChoseDialogVisible="memberChoseDialogVisible"
      @closeChild="getCloseMemberCld"
      v-on:selected="memberSelected($event)"
    ></MemberChose>
    <!-- E 选择会员 -->

    <!--S 商品汇总弹窗-->
    <GoodsSummary :goodsSummaryShow="goodsSummary" :orderno="cardOrderno" :cardData="cardVertifyData" :deliveryType="0" @closeSummaryBox="getCloseSummaryBox"></GoodsSummary>
    <!--E 商品汇总弹窗-->

    <!--S 提交成功提示框-->
    <el-dialog class="comDlog alertMsgDlog" title="系统提示" :visible.sync="submitDeliveryBox" append-to-body :close-on-click-modal="false" :before-close="closeSubmitPop">
      <div class="alertBox">
        <i class="el-icon-success"></i>
        <h2 class="comAlert">提货成功！</h2>
        <p>生成订单号：<em class="orangeColor cursorHand iconhand cityName" @click="orderCardInfo()" title="点击查看商品汇总">{{orderno}}</em></p>
        <small>点击订单号可查看当前订单所有商品汇总信息哦~</small>
      </div>
      <p class="msgBtns">
        <el-button type="primary" size="small" @click="closeSubmitPop">关闭</el-button>
      </p>
    </el-dialog>
    <!-- E 提交成功提示框 -->

    <!--S 提示可自提门店列表弹窗-->
    <el-dialog class="comDlog lowerMdg" title="该券卡不支持在当前门店自提" :visible.sync="storeVisibleShow" :close-on-click-modal="false" append-to-body>
      <div class="storesBox">
        <p class="breathTit iconbulb">当前验证券卡仅支持到以下门店自提：</p>
        <span v-for="(item,index) in canOrderStores" :key="index">{{item}}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="storeVisibleShow = false">我已了解</el-button>
      </div>
    </el-dialog>
    <!-- E 提示可自提门店列表弹窗 -->

  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Api from "@/apis/api.js";
export default {
  name: "DoorDelivery",
  components: {
    GoodsChoose: resolve =>
      require(["@/components/OrderFolder/GoodsChoose.vue"], resolve), //选择可选商品
    MemberChose: resolve =>
      require(["@/components/common/MemberChose.vue"], resolve), //选择会员
    GoodsSummary: resolve => require(["@/components/OrderFolder/GoodsSummary.vue"], resolve), //商品汇总
    DouYinVerify: resolve => require(["@/components/OrderFolder/DouYinVerify.vue"],resolve), //抖音验证
  },
  data() {
    return {
      ischeckpwd: 0,
      pubordprintinfo: null,
      presellconfig: null,
      validateLoading: false,
      submitLoading: false,
      currentCode: "",
      currentUseTimes: 1,
      currentCodeInfo: null,
      firstTimes: false,
      currentEnAbleEdite: true,
      bindMemberInfo: null,
      serviceForm: {
        verifyType: 0, //验证类型,0:卡号，1:序列号
        cardCode: "", //券卡编码
        cardPwd: "", //卡密
        cardSerial: "" //序列号
      },
      goodsDateData: [],
      cardVertifyData: [],
      goodsChoseDialogVisible: false, //选择可选商品弹框
      lookOrEdit: false, //查看or更改商品
      memberBox: false, //已选会员
      memberChoseDialogVisible: false, //选择会员弹框
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      //-------------新加商品汇总弹窗信息---------------------
      goodsSummary:false,//商品汇总弹窗
      submitDeliveryBox:false,//提交成功的提示
      orderno:'',//订单号
      cardOrderno: '', // 传递给组件的订单号
      telDeliveryForm: {
        //提货表单
        orderMemo: "", //订单备注
      },
      currentNav:0,//默认为到店自提
      isCodeScanner: false, // 是否为扫码仪模式
      storeVisibleShow:false,//提示不支持当前已选门店，查看支持预约的门店列表
      canOrderStores:[],//支持预约门店列表
    };
  },
  methods: {
    // 切换扫码仪模式
    updateScanner(val) {
      if(val) {
        this.serviceForm.verifyType = 0;
        this.$nextTick(() => {
          this.$refs.codeRef.focus();
        })
      }
    },
    // 扫码仪模式下，多选一没有默认提交订单逻辑
    scannerSubmit() {
      Api.GET_VALIDATEDCARDINFO({ code: this.currentCode }).then(res => {
        let data = res.data.data;
        let resulttype = data.resulttype;
        let codeinfo = res.data.data.codeinfo
        let optgoodsinfos = data.optgoodsinfos;
        let submitDatas ={}
        if (codeinfo.selzones==1&&optgoodsinfos[0].zoneselnum==optgoodsinfos[0].listnum) {// x选择x
          let selectGoods = {};
          let listgoods =[]
          optgoodsinfos.forEach(item => {
            item.optgoods.some(goods => {
              if (goods.cansel == 1 && goods.goodssource == 0) {
                goods.optuid = item.uid + "@" + item.sort;
                goods.optinfo = {
                  zoneselnum: item.zoneselnum,
                  listnum: item.listnum,
                  optname: item.zonename
                };
                listgoods.push(goods)
                this.$set(selectGoods, goods.optuid, listgoods);
              } 
            });
          });
          
          submitDatas = {
                  goodsinfo: selectGoods,
                  selectDefaultGoods: 1,
                  code: this.currentCode,
                  type: resulttype,
                  useTimes: 1,
                  multionescanspt: 1
                };
              if(listgoods.length!=codeinfo.selnum){
                this.$message.error('由于部分商品不可选，无法自动提交订单!')
                this.initPick();
                return
              }
                this.goodsSelectSubmit(submitDatas);
         } else if (codeinfo.selnum == 1) {
          // 专区商品关联专区标识
          let selectGoods = {};
          optgoodsinfos.forEach(item => {
            item.optgoods.some(goods => {
              if (goods.cansel == 1 && this.currentEnAbleEdite && goods.goodssource == 0) {
                goods.optuid = item.uid + "@" + item.sort;
                goods.optinfo = {
                  zoneselnum: item.zoneselnum,
                  listnum: item.listnum,
                  optname: item.zonename
                };
                this.$set(selectGoods, goods.optuid, [goods]);
                let submitData = {
                  goodsinfo: selectGoods,
                  selectDefaultGoods: 1,
                  code: this.currentCode,
                  type: resulttype,
                  useTimes: 1,
                  multionescanspt: 1
                };
                this.goodsSelectSubmit(submitData);
                return true;
              }
            });
          });
        } else {
          this.goodsChoseDialogVisible = true;
        }
      });
    },
    //切换菜单
    switchNav(val){
      this.currentNav = val;
      this.isCodeScanner = false;
    },
    // enter键确认事件 type为对应的步数
    toNext(type) {
      if(this.ischeckpwd==1) {
        if(type == 0) {
          if(this.isCodeScanner) {
            if(this.serviceForm.cardCode.indexOf('?c=')!=-1) {
              let sqsb = this.serviceForm.cardCode.substring(0,15);
              if(sqsb == 'https://th28.cn') {
                let index = this.serviceForm.cardCode.indexOf('?c=') + 3;
                this.serviceForm.cardCode = this.serviceForm.cardCode.substring(index);
              } else {
                Message.error({
                  message: "未授权设备,请联系技术客服！"
                });
                this.serviceForm.cardCode = '';
                this.$refs.codeRef.focus();
              }
            } else {
              this.$refs.pwdRef.focus();
            }
          } else {
            this.$refs.pwdRef.focus();
          }
        } else if(type == 1) {
          this.$refs.pwdRef.focus();
        } else if(type == 2) {
          this.validate()
        }
      } else {
        if(this.isCodeScanner&&type==0) {
          if(this.serviceForm.cardCode.indexOf('?c=')!=-1) {
            let sqsb = this.serviceForm.cardCode.substring(0,15);
            if(sqsb == 'https://th28.cn') {
              let index = this.serviceForm.cardCode.indexOf('?c=') + 3;
              this.serviceForm.cardCode = this.serviceForm.cardCode.substring(index);
              this.validate();
            } else {
              Message.error({
                message: "未授权设备,请联系技术客服！"
              });
              this.serviceForm.cardCode = '';
              this.$refs.codeRef.focus();
            }
          } else {
            this.validate();
          }
        } else {
          this.validate();
        }
      }
    },
    validate: function() {
      let param = { pickway: this.serviceForm.verifyType };
      param.code =
        param.pickway === 0
          ? this.serviceForm.cardCode
          : this.serviceForm.cardSerial;

      if (!param.code) {
        Message.error({
          message: "请输入" + (param.pickway === 0 ? "券卡编码" : "券卡序列号")
        });
        return;
      }
      if(param.pickway === 0&&this.serviceForm.cardCode.length!=16&&this.serviceForm.cardCode.length!=20) {
        Message.error({
          message: `请输入16位或20位券卡编码`
        });
        return;
      }
      if (this.ischeckpwd == 1) {
        param.pwd = this.serviceForm.cardPwd;
        if (!param.pwd) {
          Message.error({
            message: "请输入券卡密码"
          });
          return;
        }
      }
      this.validateLoading = true;
      Api.VALIDATE(param)
        .then(res => {
          if (res.data.status !== "200") {
            let extrOutData = (res.data.extrOutData ? res.data.extrOutData : null);
            if(extrOutData && extrOutData.extType && extrOutData.extType== 'flownames' && extrOutData.data && extrOutData.data.length>1){
              this.canOrderStores = extrOutData.data;
              this.storeVisibleShow = true; 
            }else{
              Message.error({ message: res.data.message });
            } 
            this.validateLoading = false;
            return;
          }
          let data = res.data.data;
          let codeinfo = data.codeinfo;

          let validateInfo = {
            code: codeinfo.code,
            serial: codeinfo.serial,
            sellChannel: codeinfo.channelname,
            printMemo: codeinfo.printmemo,
            memo: codeinfo.sermemo,
            cardoutmemo: data.memo,
            consumpteTimes: 1, // 默认1
            residuenum: codeinfo.residuenum,
            canChangeGoods: true,
            goods: []
          };

          this.currentEnAbleEdite = true;
          let needChooseGoods = true;
          if (data.resulttype === 0) {
            // 有默认商品，且默认商品状态可选，自动选择默认商品
            let resultinfo = data.resultinfo;
            if (resultinfo.defaultSetStatus === "000") {
              // 默认商品设置成功
              validateInfo.canChangeGoods = resultinfo.selgoods.length > 1;
              this.currentEnAbleEdite = resultinfo.selgoods.length > 1;
              validateInfo.goods = [resultinfo.selgoods[0]];
              validateInfo.goodsMap = { singleList: [resultinfo.selgoods[0]] };
              needChooseGoods = false;
              this.notForceGoodsOutDateLimitMessage(resultinfo.isoutgooddate);
            } else if (resultinfo.defaultSetStatus === "001") {
              // 只有默认商品设置失败
              MessageBox.confirm("券卡绑定商品不可用，默认商品不可用！", '系统提示', {
                confirmButtonText: '关闭',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {}).catch(() => {})
              // Message.warning({
              //   message: "券卡绑定商品不可用，默认商品不可用！"
              // });
              return;
            } else {
              // 有默认有可选，默认商品设置失败
              validateInfo.canChangeGoods = true;
              this.currentEnAbleEdite = true;
              needChooseGoods = true;
            }
          }
          if (needChooseGoods) {
            // 没有默认商品，弹出商品选择
            if (data.resultinfo.isoutcarddate === 1) {
              // this.$alert(
              //   "警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！",
              //   "系统提示",
              //   {
              //     confirmButtonText: "确定",
              //     callback: action => {
              //       this.currentCode = codeinfo.code;
              //       this.currentUseTimes = validateInfo.consumpteTimes;
              //       this.currentCodeInfo = validateInfo;
              //       this.firstTimes = true;
              //       this.goodsChoseDialogVisible = true;
              //     }
              //   }
              // );
              MessageBox.confirm("警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！", '系统提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {
                this.currentCode = codeinfo.code;
                this.currentUseTimes = validateInfo.consumpteTimes;
                this.currentCodeInfo = validateInfo;
                this.firstTimes = true;
                this.goodsChoseDialogVisible = true;
              }).catch(() => {})
            } else {
              this.currentCode = codeinfo.code;
              this.currentUseTimes = validateInfo.consumpteTimes;
              this.currentCodeInfo = validateInfo;
              this.firstTimes = true;
              if(this.ElementControls('scanautosubmit')==1&&this.ElementControls('multionescanspt')==1&&this.isCodeScanner&&(codeinfo.usenum==1 || codeinfo.residuenum==1)&&codeinfo.selzones==1) {
                this.scannerSubmit();
                this.validateLoading = false;
                this.serviceForm.cardCode = "";
                this.serviceForm.cardPwd = "";
                return;
              }
              this.goodsChoseDialogVisible = true;
            }
          } else {
            // 不强制限制券卡有效期
            this.cardVertifyData.push(validateInfo);
            this.notForceCardLimitMessage(data.resultinfo.isoutcarddate,data.resultinfo.isoutgooddate,codeinfo);
          }
          this.validateLoading = false;
          this.serviceForm.cardCode = "";
          this.serviceForm.cardPwd = "";
        })
        .catch(res => {
          this.validateLoading = false;
        });
    },
    notForceCardLimitMessage: function(iscardoutdate,isgoodsoutdate,codeinfo) {
      let forceDeliveryDate = this.pubordprintinfo.forcedeliverydate;
      if (forceDeliveryDate === 0 && iscardoutdate) {
        MessageBox.confirm("警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！", '系统提示', {
          confirmButtonText: '关闭',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {}).catch(() => {})
        // Message.warning({
        //   offset: 75,
        //   message: "警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！"
        // });
      } else if(this.ElementControls('scanautosubmit')==1&&this.isCodeScanner&&!isgoodsoutdate){
        // 选择扫码仪模式并且默认可选的时候
        if(codeinfo.usenum==1 || codeinfo.residuenum==1) {
          this.submitDeliveryForm();
        }
      }
    },
    notForceGoodsOutDateLimitMessage: function(isgoodsoutdate) {
      let forceDeliveryDate = this.pubordprintinfo.forcedeliverydate;
      if (forceDeliveryDate === 0 && isgoodsoutdate) {
        MessageBox.confirm("警示！默认商品不在销售日期内，提货需按照企业当前的发货政策进行！", '系统提示', {
          confirmButtonText: '关闭',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {}).catch(() => {})
        // Message.warning({
        //   message:
        //     "警示！默认商品不在销售日期内，提货需按照企业当前的发货政策进行！"
        // });
      }
    },
    consumpteTimesChange: function($event, item) {
      Api.SETCARDUSENUM({ code: item.code, usenum: $event }).then(res => {
        let status = res.data.status;
        if (status != 200) {
          item.consumpteTimes =
            $event - 1 > item.residuenum ? item.residuenum : $event - 1;
        }
      });
    },
    goodsSelectSubmit: function($event) {
      let param = { code: $event.code, usenum: $event.useTimes };
      let goodsInfo = $event.goodsinfo;
      let goodsInfos = [];
      let goodsMap = {};
      if ($event.type === 0) {
        // 有默认商品
        if ($event.selectDefaultGoods === 1) {
          param.isSelectDef = 1;
          param.defaultgoodscode = goodsInfo["singleList"][0].kindcode;
        } else {
          param.isSelectDef = 0;
          param.kindcodes = {};
          param.kindcodes["1"] = goodsInfo["singleList"][0].kindcode;
        }
        goodsInfos.push(goodsInfo["singleList"][0]);
        goodsMap["singleList"] = goodsInfo["singleList"];
      } else {
        // 无默认商品
        param.isSelectDef = 0;
        let kindcodes = {};

        for (let key in goodsInfo) {
          let kindcodeStr = [];
          for (let item of goodsInfo[key]) {
            kindcodeStr.push(item.kindcode);
            goodsInfos.push(item);
          }
          kindcodes[key.split("@")[1]] = kindcodeStr.join("@");
          goodsMap[key.split("@")[0]] = goodsInfo[key];
        }

        param.kindcodes = kindcodes;
      }
      this.currentCodeInfo.goods = goodsInfos;
      this.currentCodeInfo.kindcodes = param.kindcodes;
      this.currentCodeInfo.goodsMap = goodsMap;

      var hasValidateInfo = this.cardVertifyData.find(item => {
        if (item.code === this.currentCodeInfo.code) {
          return item;
        }
      });

      if (hasValidateInfo) {
        hasValidateInfo.goods = this.currentCodeInfo.goods;
        hasValidateInfo.kindcodes = this.currentCodeInfo.kindcodes;
        hasValidateInfo.goodsMap = this.currentCodeInfo.goodsMap;
      } else {
        this.cardVertifyData.push(this.currentCodeInfo);
      }

      this.currentCodeInfo = null;

      // 清空表单
      this.serviceForm.cardCode = "";
      this.serviceForm.cardSerial = "";
      this.serviceForm.cardPwd = "";

      Api.SETCARDGOODS(param).then(res => {
        if (res.data.status !== "200") {
          Message.error({ message: res.data.message });
          return;
        }else {
          if(this.isCodeScanner) {
            this.$refs.codeRef.focus();
          }
          if(this.ElementControls('scanautosubmit')==1&&this.ElementControls('multionescanspt')==1&&this.isCodeScanner&&$event.multionescanspt==1) {
            this.submitDeliveryForm();
          }
        }
      });
    },
    memberSelected: function(memberInfo) {
      this.bindMemberInfo = memberInfo;
    },
    //删除券卡验证行
    deleteRow(index) {
      Api.REMOVEVALIDATEDCARD({ code: this.cardVertifyData[index].code }).then(
        res => {
          let data = res.data;
          if (data.status === "200") {
            this.cardVertifyData.splice(index, 1);
          } else {
            Message.error({ message: data.message });
          }
        }
      );
    },
    // 打开选择可选商品弹窗
    getShowChoseGoods(item) {
      this.currentCode = item.code;
      this.currentUseTimes = item.consumpteTimes;
      this.currentCodeInfo = item;
      this.firstTimes = false;
      this.goodsChoseDialogVisible = true;
    },
    // 关闭选择可选商品弹窗
    getCloseGoodsCld() {
      if (
        this.firstTimes &&
        this.currentCodeInfo &&
        this.currentCodeInfo.code
      ) {
        Api.REMOVEVALIDATEDCARD({ code: this.currentCodeInfo.code }).then(
          res => {
            let data = res.data;
            if (data.status === "200") {
              this.goodsChoseDialogVisible = false;
              if(this.isCodeScanner) {
                this.$refs.codeRef.focus();
              }
            } else {
              Message.error({ message: data.message });
            }
          }
        );
      } else {
        this.goodsChoseDialogVisible = false;
        if(this.isCodeScanner) {
          this.$refs.codeRef.focus();
        }
      }
    },
    // 打开选择会员弹窗
    getShowChoseMem(val) {
      if (val) {
        this.memberBox = true;
      } else {
        this.memberBox = !this.bindMemberInfo;
        this.bindMemberInfo = null;
      }
      if (this.memberBox) {
        this.memberChoseDialogVisible = true;
      }
    },
    // 关闭选择会员弹窗
    getCloseMemberCld() {
      this.memberChoseDialogVisible = false;
    },
    getSubmit() {
      let jinshizun = this.ElementControls('jinshizun'); 
      if (jinshizun == 1) {
        return Api.JINSHIZUNSUBMITORDER;
      }
      return Api.SUBMITORDER;
    },
    //提交表单
    submitDeliveryForm() {
      if(this.cardVertifyData.length==0){
        this.$message.error('请先验证券卡，并设置好提货商品！')
        return
      }
      this.submitLoading = true;
      let param = {
        delimode: 0,
        terminaltype: 0,
        ordermemo: this.telDeliveryForm.orderMemo
      };
      if (this.bindMemberInfo) {
        param.membercode = this.bindMemberInfo.mcode;
      }

      this.getSubmit()(param).then(res => {
        if (res.data.status === "200") {
          // MessageBox.alert(
          //   '<div class="alertBox"><h2 class="comAlert">提货成功！</h2><p>生成订单号：' +
          //     res.data.data.orderno +
          //     "</p></div>",
          //   "系统提示",
          //   {
          //     type: "success",
          //     confirmButtonText: "确定",
          //     dangerouslyUseHTMLString: true
          //   }
          // )
          //   .then(() => {})
          //   .catch(() => {});
          this.telDeliveryForm.orderMemo = '';
          this.orderno = res.data.data.orderno;
          this.submitDeliveryBox = true;
        } else {
          Message.error({ message: res.data.message });
        }
        this.initPick();
        if(this.isCodeScanner) {
          this.$refs.codeRef.focus();
        }
        this.submitLoading = false;
      });
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.cvTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 140;
    },
    initPick: function() {
      this.cardVertifyData = [];
      Api.INITIALIZE({ delimode: 0 }).then(res => {
        if (res.data.status !== "200") {
          Message.error({ message: "提货初始化失败，请刷新重试！" });
        }
      });
    },
    //关闭商品汇总弹窗
    getCloseSummaryBox(){
      this.cardOrderno = '';
      this.goodsSummary = false;
    },
    //查看订单详情
    orderCardInfo(){
      this.cardOrderno = this.orderno;
      this.submitDeliveryBox = false;
      this.goodsSummary = true;
    },
    // 关闭订单详情弹窗
    closeSubmitPop() {
      this.cardOrderno = '';
      this.submitDeliveryBox = false;
      if(this.isCodeScanner) {
        this.$refs.codeRef.focus();
      }
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
    // 预售配置
    this.presellconfig = this.config.getPresellconfig();
    // 公共配置
    this.pubordprintinfo = this.config.getPubordprintinfo();
  },
  mounted() {
    if (localStorage.getItem("userInfoMd")) {
      this.ischeckpwd = JSON.parse(
        localStorage.getItem("userInfoMd")
      ).ischeckpwd;
    }
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight();
    }, 200);
    this.initPick();
  },
  computed: {
    serviceTypeData: function() {
      let serviceTypeData = [];
      let cuspickway = this.pubordprintinfo.cuspickway;
      serviceTypeData.push({ name: "卡号", value: 0 });
      if (cuspickway === 1) {
        serviceTypeData.push({ name: "序列号", value: 1 });
      }
      // 设置默认提货方式
      this.serviceForm.verifyType = this.pubordprintinfo.defcuspickway;

      return serviceTypeData;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
};
</script>
<style scoped>
@import "Css/Style.css";
/* .memberwidth {
  width: calc(100% - 102px) !important;
  max-width: unset;
} */
/*商品汇总start */
.goodsSummary {margin-left:30px;color:var(--main-color);font-size: 14px;}
.goodsSummary:before {padding-right:5px;}
.goodsSummary:hover {opacity:.8;}
/*确认提示框 */
.alertMsgDlog >>> .el-dialog {width:420px;border-radius:4px;overflow: hidden;padding-bottom:20px;}
.alertBox {position:relative;width:80%;margin:0 auto; padding:17px 10px 17px 36px;}
.alertBox .el-icon-success{position:absolute; left:0; top:15px;color:#67C23A;font-size: 24px;}
.msgBtns {text-align: center;padding:5px 15px 0;}
.alertMsgDlog small {color:#999;font-size: 12px;padding:10px 0;}
/*商品汇总end */
/* 提货表单样式 S */
.goodsWrap >>> .el-form-item__content {
  width: 65%;
  min-width: 200px;
  max-width: 340px;
}
.goodsWrap >>> .el-form-item__content .el-select,
.goodsWrap >>> .el-form-item__content .el-cascader,
.goodsWrap >>> .el-date-editor--daterange.el-input__inner,
.goodsWrap >>> .el-form-item__content .el-date-editor {
  width: 100%;
}
.goodsWrap {
  width: 100%;
  -webkit-display: flex;
  display: flex;
}
.deliveryForm .commonTit {
  margin-bottom: 30px;
  margin-top: 20px;
}
.goodsWrap >>> .el-form-item.mb0 {
  margin-bottom: 0;
}
/* 提货表单样式 E */

/*可自提门店列表 */
.storesBox {padding:20px 0;}
.storesBox span {display: inline-block; margin:10px; padding:0 15px; line-height:25px; border:solid 1px #ebeefe; border-radius:12.5px; color:#666;}
</style>





// WEBPACK FOOTER //
// src/views/OrderFolder/DoorDeliery.vue